import type { IxcFeesV1FeeRateKeys, IxcFeesV1FeeType } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FEE_RATE_BASE_PATH = getResolvedPath('/clearing/finance/middle-money/fee-rate');

export const getFeeRatePath: EntityPathBuilder<IxcFeesV1FeeRateKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FEE_RATE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.feeType || !context?.keys?.effectiveDate) {
        return undefined;
      }

      return getResolvedPath(`${FEE_RATE_BASE_PATH}/$feeType/$effectiveDate`, context.keys);
    }
  }
};

export function getFeeRateDetailPath(feeType: IxcFeesV1FeeType | undefined, effectiveDate: string | undefined) {
  if (!feeType) {
    return undefined;
  }

  return getFeeRatePath({ kind: 'detail', keys: { feeType, effectiveDate } });
}
